import { useState } from 'react';

import { useShowMore } from 'hooks';
import { formatPrice } from 'utils/helpers';
import { EventCheckout } from 'store/api/event';
import { formatTimezoneSpecific } from 'utils/date';
import { TemplateList } from 'components/transactions-list';

import { ExchangeDetails } from './details';
import { ExchangesListProps } from './types';
import { calculateDifferenceExchangeAndCheckoutItems } from './helpers';

const template = '1fr 2fr repeat(3, 1fr)';
const headers = [
  'Date',
  'Event Name',
  'Sale Total',
  'Return Amount',
  'Exchange Amount',
];

export const ExchangesList = ({ data }: ExchangesListProps) => {
  const [selectedExchange, setSelectedExchange] = useState<EventCheckout>();
  const { visibleData, ...showMoreProps } = useShowMore(data);

  return (
    <>
      <TemplateList<EventCheckout>
        title="Exchanges"
        headers={headers}
        data={visibleData}
        template={template}
        hasMinHeight={false}
        listProps={showMoreProps}
        tabletTemplate={template}
        maxHeight={visibleData?.length ? 350 : undefined}
        onClick={(e, value) => setSelectedExchange(value)}
        render={(exchange) => [
          formatTimezoneSpecific(
            exchange.createdAt,
            exchange?.event?.timezone?.code
          ),
          exchange?.event?.name,
          formatPrice(exchange.saleTotal),
          formatPrice(exchange?.exchangeItemsAmount),
          formatPrice(calculateDifferenceExchangeAndCheckoutItems(exchange)),
        ]}
      />

      <ExchangeDetails
        data={selectedExchange}
        opened={!!selectedExchange}
        onClose={() => setSelectedExchange(undefined)}
      />
    </>
  );
};
